import React from 'react';
import DOMPurify from 'dompurify'; // Import the DOMPurify library
import _ from 'lodash';

const MANAGED_PROPS = ['additionalContent'];

const withAdditionalContent = (WrappedComponent) => {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {};
    }

    sanitizeHTML = (html) => {
      return DOMPurify.sanitize(html); // Sanitize the HTML content
    };

    render = () => {
      const filteredProps = _.omit(this.props, MANAGED_PROPS);
      const additionalContent = this.props.additionalContent;
      const contentToPrepend = _.filter(additionalContent, {type: 'prepend'});
      const contentToAppend = _.filter(additionalContent, {type: 'append'});

      return (
        <React.Fragment>
          {contentToPrepend.map((content) => (
            <div dangerouslySetInnerHTML={{__html: this.sanitizeHTML(content.content)}} />
          ))}
          <WrappedComponent {...filteredProps} />
          {contentToAppend.map((content) => (
            <div dangerouslySetInnerHTML={{__html: this.sanitizeHTML(content.content)}} />
          ))}
        </React.Fragment>
      );
    };
  };
};

export default withAdditionalContent;
